<template>
  <lazy-component class="article-videos">
    <div class="article-videos__image">
      <a
        class="article-videos__content--link"
        :href="video.url"
      >
        <img
          :src="video.featuredImage"
          :alt="video.title"
        >
      </a>
      <div class="article-videos__duration">
        <i class="fa fa-play" style="color:red; margin-right: 0.3rem; font-size: 12px;"></i>
        <span>{{ durationFormatted }}</span>
      </div>
    </div>
    <div class="article-videos__content">
      <a
        class="article-videos__content--link"
        :href="video.url"
      >
        <h2
          class="title article-videos__title"
          style="-webkit-box-orient: vertical"
        >
          {{ video.title }}
        </h2>
        <h4
          class="title article-videos__subtitle"
          style="-webkit-box-orient: vertical"
        >
          {{ video.subtitle }}
        </h4>
      </a>
      <div class="article-videos__footer">
        <label class="article-videos__footer--info">
          <template v-if="video.publishedAt">
            {{ formattedPublishedAt }}
          </template>
        </label>
        <div class="line_footer"></div>
        <div
          v-if="video.formattedViews"
          class="article-videos__footer--views"
        >
          <label class="views-text">
            VIEWS
          </label>
          <i class="bandwagon-logo bandwagon-logo--arc" />
          <label class="article-videos__views--number">
            {{ video.formattedViews }}
          </label>
        </div>
      </div>
    </div>
  </lazy-component>
</template>

<script>
export default {
  name: 'ArticleVideoBlockComponent',
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    formattedPublishedAt() {
      if (this.video.publishedAt === undefined) return null;

      return new Date(this.video.publishedAt).toLocaleString('en-SG', {
        year: 'numeric',
        month: this.$isMobile ? 'short' : 'long',
        day: 'numeric',
      });
    },

    durationFormatted() {
      const duration = Number(this.video.duration);
      let hours = Math.floor(duration / 3600);
      const minutes = Math.floor((duration - hours * 3600) / 60).toString().padStart(2, 0);
      const seconds = Math.floor(duration % 60).toString().padStart(2, 0);

      hours = hours > 0 ? `${hours.toString()}:` : '';

      return `${hours}${minutes}:${seconds}`;
    },
  },
};
</script>
